export default "__VITE_ASSET__94_9MeG4__"